<div class="request-banner">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-6">
      <div
        class="container flex flex-column align-items-center justify-content-center gap-5 h-full"
      >
        <h3 class="mb-0">
          Non riesci a trovare il
          <span class="yellow">viaggio</span>
          <img src="/assets/media/icons/airplane.png" width="30" />
          che cercavi?
        </h3>
        <span class="text-center"
          >Contattaci e raccontaci come vorresti sia il tuo prossimo
          viaggio!</span
        >
        <div>
          <p-button
            styleClass="px-6 slide"
            label="Invia una richiesta"
            routerLink="/info/add-request"
          ></p-button>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-12 lg:col-6 p-0">
      <div class="img-container">
        <div class="banner-icon"></div>
        <div class="img-1">
          <div class="dashed-line"></div>
        </div>
      </div>
    </div>
  </div>
</div>
